import { Component } from '@angular/core';
import { IHeaderAngularComp } from '@ag-grid-community/angular';
import { IHeaderParams } from '@ag-grid-community/all-modules';

@Component({
    selector: 'pershing-grid-header',
    templateUrl: './pershing-grid-header.component.html'
})
export class PershingGridHeaderComponent implements IHeaderAngularComp {
    sortState: string = 'noSort';
    headerName: string;
    canSort: boolean;
    hoverStyle: string = '';

    private sortOrder = [ 'noSort', 'asc', 'desc' ];
    private stateIndex = 0;
    private params: IHeaderParams;

    agInit(params: IHeaderParams): void {
        this.params = params;
        this.headerName = params.displayName;
        this.canSort = params.enableSorting;
        this.determineSortState();
        params.column.addEventListener('sortChanged', this.onSortChanged.bind(this));
    }

    /**
     * Set the next sort order
     * // TODO: Use event to capture shift click for possible multi-sort?
     * @param event
     */
    onSortRequested(event: any) {
        this.stateIndex = (this.stateIndex + 1) % 3;
        let sort: string = this.sortOrder[this.stateIndex];
        sort = sort === 'noSort' ? null : sort;
        this.params.setSort(sort, event.shiftKey);
    }

    /**
     * Invoked whenever the column listens to the sortChanged event emitted by the grid.
     * This will set the sortState.
     */
    onSortChanged(): void {
        let sortState = this.params.column.getSort();
        if (!sortState) {
            this.sortState = 'noSort';
        } else {
            this.sortState = sortState;
        }
    }

    refresh(params: IHeaderParams) {
    return true;
    }
    /**
     * Determine the sort state and order of the column if values are already present
     */
    determineSortState(): void {
        let sortModel: any[] = this.params.columnApi.getColumnState().filter(item => item.sort != null);
        sortModel.forEach(sortFilter => {
            if (sortFilter.colId === this.params.column.getColId()) {
                this.sortState = sortFilter.sort;
            }
        });
        this.stateIndex = this.sortOrder.indexOf(this.sortState);
    }

    /**
     * Return true if rows are rendered in the grid. Return false if no rows are displayed.
     */
    rowsLoaded(): boolean {
        return this.params.api.getRenderedNodes().length !== 0;
    }
}
